import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";
import useToast from "hooks/useToast";
import { DeleteAddress, FavAdress, PMyPreferences, UiModal } from "libs/raas-ui-react-components/src/components"
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { addressTypes, AdressesTypesByLiteral, DeleteAdressModalLiterals, deleteUserAdresses, mapAddressesApiData, mapPreferencesApiData, MapPreferencesData, postUserAdresses, PreferencesData, putUserAdresses ,PMyPreferenesLiterals, getFavAdressLiterals} from "./Preferences.service";
import "./Preferences.scss"
import { getUserData, putPreferencesData } from "services/user/user-micros.service";
import useSession from "hooks/useSession";
import { useTranslation } from "react-i18next";
import { setItemStorage } from "services/util/sessionStorage.service";
declare const window: any;
export const Preferences = () => {
    const [t] = useTranslation('preferences');
    const recentAddressesKey = "raas-recent-addresses";
    const navigate = useNavigate()
    const { openToast } = useToast();
    const { setUserConnected} = useSession();

    const [editMode, setEditMode] = useState(false) as any;
    const [preferencesData, setPreferencesData] = useState({}) as any;
    const [addresses, setAddresses] = useState([]) as any;
    const [openAdressModal, setopenAdressModal] = useState(false);
    const [openDeleteAdressModal, setopenDeleteAdressModal] = useState(false);
    const [addressTouched, setAddressTouched] = useState("");
    const [initialAddresses, setinitialAddresses] = useState([]) as any;
    const [recentAddresses, setreccentAddresses] = useState([]) as any;
    const [deleteAdressItem, setDeleteAddressItem] = useState({}) as any;
    const [deleteAdressIcon, setdeleteAdressIcon] = useState("");
    const favAdressLiterals=getFavAdressLiterals(t)
    useEffect(() => {
        getUserData((data: any) => {

            setUserConnected(data?.data);
            setreccentAddresses(getAddressesStorage());
            const addressesObj = mapInitialAddresses(data);
            setinitialAddresses([...addressesObj])
            setAddresses([...addressesObj]);
            getFavoriteAddresses([...addressesObj]);
            setPreferencesData(MapPreferencesData(data))
        }, (error: any) => {
            console.error(error);
            openToast("error", t("literals.preferencesError"), t("literals.FailedToSaveData"))
        })
    }, [])

    const getFavoriteAddresses = (array: Array<any>) => {
        setItemStorage('addresses-fav', array);
    }

    const getAddressesStorage = () => {
        return JSON.parse(sessionStorage[recentAddressesKey] || "[]");
    }

    const setNewRecentAddress = (obj: any) =>{
        const newStorage = [...recentAddresses, obj]
        if(newStorage.length<=10){
            setreccentAddresses(newStorage);
            sessionStorage.setItem(recentAddressesKey, JSON.stringify(newStorage));
        }

    }

    const deleteRecentAddresses = () => {
        const newStorage: any = [];
        setreccentAddresses(newStorage);
        sessionStorage.setItem(recentAddressesKey, JSON.stringify(newStorage));
    }

    const mapInitialAddresses = (data: any) => {
        return data?.data?.addresses.map((el: any) => {
            return {
                label: el.label,
                new: false,
                description: el.description,
                hafasId: el.hafasId,
                id: el.id
            }
        });
    }

    const handleAddAdress = (event: CustomEvent) => {    
        if(event?.detail){
            setNewRecentAddress(event.detail)
            let _addresses = addresses;
            const edit = addresses.find((el: any) => el.label === addressTouched);
           
            if (edit) {
                _addresses = addresses.map((el: any) => {
                    if (el.label === addressTouched) {
                        return {
                            label: addressTouched,
                            new: true,
                            description: event.detail.name,
                            hafasId: event.detail.id,
                            id: 0
                        }
                    } else {
                        return el;
                    }
                })
            } else {
                _addresses.push({
                    label: addressTouched,
                    new: true,
                    description: event.detail.name,
                    hafasId: event.detail.id,
                    id: 0
                })
            }
            setAddresses([..._addresses]);
            setopenAdressModal(false);
        }
    }

    const handleSavePreferences = (e: CustomEvent) => {
        const body = mapPreferencesApiData(e.detail,t)
        setPreferencesData(e.detail);
        putPreferencesData(body, () => {
            handleAddresses(() => {
                navigate("/my-profile")
            })
        }, () => {
            openToast("error", t("literals.preferencesError"), t("literals.FailedToSaveData"))
        })
    }

    const handleAddresses = async (callback: Function) => {
        const hasChange = addresses != initialAddresses;
        let promises = [];
        if (hasChange) {
            let oldHomeAddress = findInitialAddress(addressTypes.Home, initialAddresses);
            let oldWorkAddress = findInitialAddress(addressTypes.Work, initialAddresses);
            let HomeAddress = findInitialAddress(addressTypes.Home, addresses);
            let WorkAddress = findInitialAddress(addressTypes.Work, addresses);
            if (oldHomeAddress != HomeAddress) {
                if (!oldHomeAddress) promises.push(postUserAdresses(mapAddressesApiData(HomeAddress, addressTypes.Home))) //create
                else if (!HomeAddress) promises.push(deleteUserAdresses(oldHomeAddress.id)) //delete
                else promises.push(putUserAdresses(mapAddressesApiData(HomeAddress, addressTypes.Home), oldHomeAddress.id)) //update
            }
            if (oldWorkAddress != WorkAddress) {
                if (!oldWorkAddress) promises.push(postUserAdresses(mapAddressesApiData(WorkAddress, addressTypes.Work))) //create
                else if (!WorkAddress) promises.push(deleteUserAdresses(oldWorkAddress.id)) //delete
                else promises.push(putUserAdresses(mapAddressesApiData(WorkAddress, addressTypes.Work), oldWorkAddress.id)) //update
            }
            Promise.all(promises)
                .then((data: any) => {
                    sessionStorage.removeItem("addresses-fav");
                    callback(data)
                })
                .catch((error: any) => callback(error))

        } else {
            callback(null)
        }
    }

    const findInitialAddress = (label: string, initialAddressesObj: any) => {
        return initialAddressesObj.find((el: any) => el.label == label);
    }

    const handleDeleteAdress = (e: CustomEvent) => {
        // mostrar modal de borrar preferencias, 
        setAddressTouched(deleteAdressItem.label);
        const label = deleteAdressItem.label;
        let _addresses: any = []
        addresses.forEach((el: any) => {
            if (el.label !== label) _addresses.push(el);
        })
        setAddresses([..._addresses]);
        setopenDeleteAdressModal(false)

    }

    const handleOpenModal = (ev: CustomEvent) => {
        window.dataLayer?.push({
            event:"page_view",
            screen_name: 'favorite_addresses_add_new_',
            screen_class: 'profile',
          });
        if (ev.type === "editAdress") {
            setEditMode(true)
            setAddressTouched(ev.detail.label)
        } else {
            setEditMode(false)
            let id: string = ev.detail.id;
            let a = AdressesTypesByLiteral[id]
            setAddressTouched(a);
        }
        setopenAdressModal(true)
   
    }

    const mapIconModal = (e: CustomEvent) => {
        if (e.detail.label == "sys:HOME") return 'house'
        else return 'work'
    }



    return (
        <div>
            <PMyPreferences
                literals={PMyPreferenesLiterals(t)}
                tripModality={preferencesData.tripModality}
                tripPreferencesLessWalk={preferencesData.tripPreferencesLessWalk}
                tripPreferencesMoreTime={preferencesData.tripPreferencesMoreTime}
                addressesPreferences={addresses}
                onEditAdress={(e) => handleOpenModal(e)}
                onAddAdress={(e) => handleOpenModal(e)}
                onDeleteAdress={(e) => {
                    setopenDeleteAdressModal(true); setDeleteAddressItem(e.detail); setdeleteAdressIcon(mapIconModal(e))
                } /*(e) => handleDeleteAdress(e)*/}
                onSavePreferences={(e) => handleSavePreferences(e)}
            />
            <UiModal notUseShiftLogic={true} open={openAdressModal} blockOverlay={true}>
                <FavAdress
                    literals={favAdressLiterals}
                    editMode={editMode}
                    recentAddresses={recentAddresses}
                    onCloseModal={() => setopenAdressModal(false)}
                    onEraseAdressModal={() => deleteRecentAddresses()}
                    onAddAdressModal={(e) => handleAddAdress(e)}>
                </FavAdress>
            </UiModal>
            <UiModal open={openDeleteAdressModal} blockOverlay={true}>
                <DeleteAddress
                    literals={JSON.stringify(DeleteAdressModalLiterals(t).literals)}
                    adressName={deleteAdressItem.description}
                    iconName={deleteAdressIcon}
                    onCloseModal={() => setopenDeleteAdressModal(false)}
                    onDeleteAdress={(e) => handleDeleteAdress(e)}/* AQUI BORRAR LA DIRECION FAVORITA */>
                </DeleteAddress>
            </UiModal>
            <div className="mt-96">
                <PrivatePagesWrapper></PrivatePagesWrapper>
            </div>
        </div>
    )
}
